import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {Directive, Input} from '@angular/core';

@Directive({
	selector: '[falseyRequired]',
	providers: [{provide: NG_VALIDATORS, useExisting: FalseyRequiredDirectiveValidator, multi: true}]
})
export class FalseyRequiredDirectiveValidator implements Validator {
	@Input() falseyRequired = true;

	validate(control: AbstractControl): {[key: string]: any} | null {
		return this.falseyRequired && (!control.value || control.value == '0') ? {'falseyRequried': control.value} : null;
	}
}